import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { recordPublicPageView } from "./executive";

const privatePrefixes = ["/mi", "/gestion", "/academia/mi-aprendizaje"];

export function PortalAnalytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (privatePrefixes.some((prefix) => pathname.startsWith(prefix))) return;
    void recordPublicPageView(pathname).catch(() => undefined);
  }, [pathname]);

  return null;
}
